import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "First traditional pub&bar crawl 2009",
  "description": "",
  "published": "2009-09-23T00:00:00.000Z",
  "redirect_from": ["/blog/first-traditional-pubbar-crawl-2009/swizec/740"],
  "categories": "intrigues, Pub crawl, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://profile.ak.fbcdn.net/object2/1151/106/n151604063816_7893.jpg",
        "alt": "Pub&bar crawl 2009",
        "title": "Pub&bar crawl 2009"
      }}></img></p>
    <p>{`Lately I've been listening to a lot of Irish Punk, well it's really American `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Celtic_punk",
        "title": "Celtic punk"
      }}>{`Celtic Punk`}</a>{` because some americans there feel they should honour their Irish roots, then again the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Celts",
        "title": "Celts"
      }}>{`Celts`}</a>{` never really lived in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Ireland",
        "title": "Ireland"
      }}>{`Ireland`}</a>{` so the whole thing doesn't make sense and ... but anyway, I've been listening to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Flogging_Molly",
        "title": "Flogging Molly"
      }}>{`Flogging Molly`}</a>{` a rather great deal.`}</p>
    <p>{`Having been listening to this stuff I've grown a big and bloody huge inclination to getting absolutely plastered and do some stupid shit.`}</p>
    <p>{`And I'm quite possibly passing all the exams I have to this week so I can advance my MMORPG-life level and that needs to be celebrated with alcohol and drunkedness.`}</p>
    <p>{`Or I may not pass them and then my sorrows need to be drowned with alcohol and drunkedness.`}</p>
    <p>{`Also, I've been feeling lately as if there aren't enough traditions in the world and that we should start some new ones.`}</p>
    <p>{`So I came up with the idea of creating a traditional `}<a parentName="p" {...{
        "href": "http://www.facebook.com/event.php?eid=151604063816&ref=mf"
      }}>{`end-of-all-uni-exams-of-the-year`}</a>{` `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Public_house",
        "title": "Public house"
      }}>{`pub`}</a>{`&`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Pub_crawl",
        "title": "Pub crawl"
      }}>{`bar crawl`}</a>{`. In this event I would drum up everyone I can possibly think of that could be going through something akin to passing all exams and might want to get plastered with a bunch of idiots.`}</p>
    <p>{`The idea is to start off at Zeleni Zajec this Friday at eight-ish and have a few drinks. Then move on to a nearby pub for a few more drinks. And so on and on ad nauseum until we can't possibly move further. I would be incredibly happy if many many people came because the more the merrier.`}</p>
    <p>{`Hey, maybe next year we can get some official t-shirts made and make the whole thing even more fun.`}</p>
    <p>{`It would also be very helpful if everyone who intends to come get drunk with us would kindly tag themselves on the `}<a parentName="p" {...{
        "href": "http://www.facebook.com/event.php?eid=151604063816&ref=mf"
      }}>{`facebook grog fest`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/5b1f3817-8f6f-4c8a-b024-05c5a097a229/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=5b1f3817-8f6f-4c8a-b024-05c5a097a229",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      